import SgiComponent from "./SgiComponent";
import { getConstByKey, testReactVsn, getFunctionByKey } from "./SgiCommon";

export default class SgiCtnComponent extends SgiComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,//由super构造器产生
            ctnWrapProps: {},//ctn容器属性
            ctnHeadProps: {},//ctnhead属性
            ctnBodyProps: {},//ctnbody属性
        };
    }

    _maker(parentModule, moduleDesc, objFct, type) {
        super._maker(parentModule, moduleDesc, objFct, type);

        // 获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        // 转换容器公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.ctnWrapProps, this.state.ctnHeadProps, this.state.ctnBodyProps);
    }

    setHidden(value) {
        let props = this.state.formProps || this.state.panelProps || this.state.tabsProps
            || this.state.collapseProps || this.state.CardProps;
        if (value) {
            props.style.display = "none"
        } else {
            props.style.display = undefined;
        }
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            props.style = {...props.style};
        }
        this.setState({ loading: false });
    }

    add(module) {
        if (!module) {
            return;
        }
        let sonItems = this.state.formItems || this.state.panelItems;
        if (!sonItems) {
            return;
        }
        sonItems.push(module);
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            sonItems = [...sonItems];
        }
        this.setState({ loading: false })
    }

    removeAll() {
        this.props.moduleDesc.cldSet = [];
        this.refresh();
    }

    /**
     * id 可能为guid 可能为cid
     */
    remove(id) {
        if (!id) {
            return;
        }
        let sonItems = this.props.moduleDesc.cldSet;
        if (!sonItems) {
            return;
        }
        let tmpItem;
        let tmpId;
        for (var i = 0; i < sonItems.length; i++) {
            tmpItem = sonItems[i];
            if (!tmpItem) {
                continue;
            }
            tmpId = tmpItem.guid || getConstByKey(this, tmpItem.cId);
            if (id == tmpId) {
                sonItems.splice(i, 1);
                break;
            }
        }
        this.refresh();
    }

    setLoading(loading) {
        this.setState({ loading });
    }

    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
    renderBeforeReturn(ctnProps) {
        const { parentModule, moduleDesc, objFct, type } = this.props;

        // 自定义样式处理
        // const getCstmStyle = this.state.cstmStyle;
        const getCstmStyle = getFunctionByKey(this, "cstmStyle");
        let cstmStyle = {};
        if (getCstmStyle) {
            try {
                cstmStyle = getCstmStyle(this, objFct) || {};
            } catch (error) {
                tool.sgiLogger.log(error);
            }
        }
        Object.assign(ctnProps.style, cstmStyle);

    }

}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiBaseComp/SgiCtnComponent.js